<div class="flex-col h-100 w-100 p-24 uniform-container">
  <div class="tabs flex-row">
    <span class="tab c-p" [class.active]="currentTab() === 'existing'" (click)="setActiveTab('existing')">
      <span class="ui-icon-existing-uniform tab-icon"></span>
      <span class="tab-text">{{ 'UNIFORM.EXISTING_TAB' | translate }}</span>
    </span>
    <span class="tab c-p" [class.active]="currentTab() === 'unsaved'" (click)="setActiveTab('unsaved')">
      <span class="ui-icon-unsaved-uniform tab-icon"></span>
      <span class="tab-text">{{ 'UNIFORM.UNSAVED_TAB' | translate }}</span>
    </span>
  </div>

  <div class="tab-content">
    <ng-container *ngIf="currentTab() === 'existing'">
      <app-existing-uniforms class="w-100 h-100" (navigateToUnsaved)="setActiveTab('unsaved')"></app-existing-uniforms>
    </ng-container>

    <ng-container *ngIf="currentTab() === 'unsaved'">
      <app-unsaved-uniforms class="w-100 h-100"></app-unsaved-uniforms>
    </ng-container>
  </div>
</div>
